// extracted by mini-css-extract-plugin
export var banner = "_2v-0";
export var icon = "_2v-1";
export var message = "_2v-2";